import React, { useEffect } from 'react';
import chatPerson from "../../../images/img/chat-person.png"
import ReactHtmlParser from 'react-html-parser';

const MessageA2 = (props) => {
    // let finalstr;

    // const text = props.item && props.item.text && props.item.text.split('</a>')
    // const data =  text && text.map( i => (
    //     i.split('<a') 
    // ))
    // const a = data.map( i => i[1])
    // const handleSomething = () => {
    //     props.handleClick(props.item.code)
    // }

    const handleChange = (e) => {
        // console.log("handlea2change",e,e.target,e.target.tagName)
        if(e.target.tagName === "SPAN")
        {
            props.handleClick(props.item.code)
            props.setTextOnClick("Emergency Top-up service")
        }
    }
   
    let text = props.item && props.item.text;
    text = text.replace('Emergency Top-up service','<span style="color:#e940ad;">Emergency Top-up service</a> ')
    // console.log("a2props",props,text)


    return(
         <div style={{display:'flex',width:'100%'}}>
        <div className="chat-person" style={{ marginTop: '10px' }}>
                <img src={chatPerson} alt="" /> </div>
        <div className="chat-text" style={{ margin: '10px 0px' }} onClick={handleChange} dangerouslySetInnerHTML={{__html:text}}  >
        {/* { ReactHtmlParser(text) } */}
               </div>
               </div>
    )
}


export default MessageA2;